import React from 'react';

const OtherSkills = () => {
    return (
        <div className="otherSkills">
            <h3>Autres Compétences</h3>
                <div className="list">
                <ul>
                    <li><i className="far fa-check-circle"></i>
                    Anglais courant</li>
                    <li><i className="far fa-check-circle"></i>
                    Italien courant</li>
                    <li><i className="far fa-check-circle"></i>
                    Github</li>
                    <li><i className="far fa-check-circle"></i>
                    Méthodes agiles</li>
                </ul>
                <ul>
                    <li><i className="far fa-check-circle"></i>
                    Architecture et conception</li>
                    <li><i className="far fa-check-circle"></i>
                    Communication écrite et orale < /li>
                    <li><i className="far fa-check-circle"></i>
                    Esprit d 'équipe</li>
                    <li><i className="far fa-check-circle"></i>
                    Prospection commerciale</li>
                </ul>
                <ul>
                    <li><i className="far fa-check-circle"></i>
                    Relations commerciales</li>
                    <li><i className="far fa-check-circle"></i>
                    Gestion, management </li>
                    <li><i className="far fa-check-circle"></i>
                    Sens relationnel < /li>
                    <li><i className="far fa-check-circle"></i>
                    Reporting et suivis</li>
                </ul>
            </div>
        </div>
    );
};

export default OtherSkills;